import { useLayoutEffect, useState } from "react";

function activeToastHost(): HTMLElement {
  const dialogs = Array.from(document.querySelectorAll<HTMLElement>('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]'));
  return dialogs.reverse().find((dialog) => !dialog.closest('[aria-hidden="true"], [inert]')) ?? document.body;
}

// Keep notifications inside the active focus scope, not merely above its backdrop.
export function useToastViewportHost() {
  const [host, setHost] = useState<HTMLElement | null>(() => typeof document === "undefined" ? null : activeToastHost());
  useLayoutEffect(() => {
    const update = () => {
      const next = activeToastHost();
      setHost((current) => current === next ? current : next);
    };
    const observer = new MutationObserver(update);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-state", "aria-hidden", "inert"] });
    update();
    return () => observer.disconnect();
  }, []);
  return host;
}
